import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface PlayerEmoji {
  playerId: string;
  emoji: string | undefined;
}

interface EmojiState {
  gameId: string | null;
  emojis: PlayerEmoji[];
}

const initialState: EmojiState = {
  gameId: null,
  emojis: [],
}

const emojiSlice = createSlice({
  name: 'emoji',
  initialState,
  reducers: {

    sendEmoji: ((state, action: PayloadAction<{
      gameId: string,
      emoji: string | null,
      playerId: string
    }>) => {
      return;
    }),

    receiveEmoji: ((state, action: PayloadAction<any>) => {

      if (state.gameId && state.gameId !== action.payload.gameId) {
        return;
      }

      for (const it of state.emojis) {
        if (it.playerId === action.payload.playerId) {
          it.emoji = action.payload.emoji;
          return;
        }
      }

      state.gameId = action.payload.gameId;
      state.emojis.push({
        emoji: action.payload.emoji,
        playerId: action.payload.playerId,
      });

    }),

    stopEmoji: ((state, action: PayloadAction<any>) => {
      for (const it of state.emojis) {
        if (it.playerId === action.payload.playerId) {
          it.emoji = undefined;
          return;
        }
      }
    }),
  },
});

export const emojiActions = emojiSlice.actions;
export default emojiSlice.reducer;
